import { UploadOutlined } from "@ant-design/icons";
import { Col, message, Modal, Row, Spin, Upload } from "antd";
import React, { useState } from "react";

import { uploadToCloudinary } from "api/services/teacher/teacher.services";
import { StatusCode } from "common/enums";
import Avatar_1 from "../../assets/images/app/avatars/avatar_1.svg";
import Avatar_2 from "../../assets/images/app/avatars/avatar_2.svg";
import Avatar_3 from "../../assets/images/app/avatars/avatar_3.svg";
import Avatar_4 from "../../assets/images/app/avatars/avatar_4.svg";
import Avatar_5 from "../../assets/images/app/avatars/avatar_5.svg";
import Avatar_6 from "../../assets/images/app/avatars/avatar_6.svg";
import Avatar_7 from "../../assets/images/app/avatars/avatar_7.svg";
import Avatar_8 from "../../assets/images/app/avatars/avatar_8.svg";

interface AvatarItem {
    name: string;
    image: any;
    url?: string;
}

const avatars: AvatarItem[] = [
    { name: "upload", image: UploadOutlined },
    { name: "avatar_1", image: Avatar_1, url: "https://res.cloudinary.com/dcfvrpurc/image/upload/v1761905248/avatars/avatar_1_bkr0qz.svg" },
    { name: "avatar_2", image: Avatar_2, url: "https://res.cloudinary.com/dcfvrpurc/image/upload/v1761905248/avatars/avatar_2_up5ggl.svg" },
    { name: "avatar_3", image: Avatar_3, url: "https://res.cloudinary.com/dcfvrpurc/image/upload/v1761905248/avatars/avatar_3_kbdotz.svg" },
    { name: "avatar_4", image: Avatar_4, url: "https://res.cloudinary.com/dcfvrpurc/image/upload/v1761905249/avatars/avatar_4_avspu0.svg" },
    { name: "avatar_5", image: Avatar_5, url: "https://res.cloudinary.com/dcfvrpurc/image/upload/v1761905250/avatars/avatar_5_ymzvak.svg" },
    { name: "avatar_6", image: Avatar_6, url: "https://res.cloudinary.com/dcfvrpurc/image/upload/v1761905249/avatars/avatar_6_loqgre.svg" },
    { name: "avatar_7", image: Avatar_7, url: "https://res.cloudinary.com/dcfvrpurc/image/upload/v1761905248/avatars/avatar_7_fjdqhz.svg" },
    { name: "avatar_8", image: Avatar_8, url: "https://res.cloudinary.com/dcfvrpurc/image/upload/v1761905250/avatars/avatar_8_jnvsrh.svg" },
];

const AvatarModal: React.FC<{
    visible: boolean;
    onCancel: () => void;
    onSelect: (avatar: string) => void;
}> = ({ visible, onCancel, onSelect }) => {

    const [loading, setLoading] = useState(false);

    const handleUpload = async (file: File) => {
        setLoading(true);
        // Upload
        try {
            const response = await uploadToCloudinary(file, "photoProfil");

            if (response?.statusCode === StatusCode.CREATED) {
                if (response?.data !== 'Face not detected') {
                    const secureUrl = response?.data.replace(/^http:\/\//i, "https://");
                    onSelect(secureUrl);
                    setLoading(false);
                }
                else {
                    message.warning({
                        content: "Visage non detecté, merci de réessayer.",
                    });
                    setLoading(false);
                }
            }
            else {
                message.warning({
                    content: "Une erreur est survenue",
                });
                setLoading(false);
            }
        } catch (error: any) {
            let content = "";
            for (
                let index = 0;
                index < error?.response?.data?.message?.length;
                index++
            ) {
                content = error?.response?.data?.message[index] + ", " + content;
            }
            message.error({
                content: content,
            });
            setLoading(false);
        }
        return false; // Prevent auto upload
    };

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width={550}
            centered
            closable
            style={{ borderRadius: 20, overflow: "hidden" }}
            modalRender={(node) => (
                <div style={{ borderRadius: 20, overflow: "hidden" }}>{node}</div>
            )}
        >
            <Row gutter={[20, 20]} justify="center">
                {loading ? <Spin size="large" /> : avatars.map((avatar, index) => (
                    <Col span={8} key={index} style={{ textAlign: "center" }}>
                        {avatar.name === "upload" ? (
                            <Upload
                                multiple={false}
                                beforeUpload={handleUpload}
                                showUploadList={false}
                                maxCount={1}
                                accept="image/*"
                            >
                                <div
                                    style={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: "50%",
                                        background: "#f5f5f5",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        border: "1px dashed #d9d9d9",
                                    }}
                                >
                                    <UploadOutlined style={{ fontSize: 24, color: "#999" }} />
                                </div>
                            </Upload>
                        ) : (
                            <img
                                src={avatar?.image}
                                height={80}
                                style={{
                                    cursor: "pointer",
                                    border: "2px solid transparent",
                                    transition: "all 0.2s",
                                }}
                                onClick={() => onSelect(avatar?.url!)}
                                onMouseOver={(e: any) => {
                                    const target = e.target as HTMLElement;
                                    target.style.border = "2px solid #7FB1B2";
                                    target.style.borderRadius = "50%";
                                    target.style.transform = "scale(1.1)";
                                }}
                                onMouseOut={(e: any) => {
                                    const target = e.target as HTMLElement;
                                    target.style.border = "none";
                                    target.style.transform = "scale(1)";
                                }}
                            />
                        )}
                    </Col>
                ))}
            </Row>
        </Modal>
    );
};

export default AvatarModal;
